/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

const callTranslations = {
  callStatus: {
    initializing: "Vorbereiten...",
    ready: "Bereit zum Telefonieren",
    ended: "Anruf beendet",
    failed: "Anruf fehlgeschlagen",
    inCallWithInboundCaller: "Im Gespräch mit eingehendem Anrufer",
  },
};

export default callTranslations;
